/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthStrictHttpResponse } from '../../auth-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PractitionerSaveModel } from '../../models/practitioner-save-model';

export interface UserSetUserPractionerIdPost$Params {
      body?: PractitionerSaveModel
}

export function userSetUserPractionerIdPost(http: HttpClient, rootUrl: string, params?: UserSetUserPractionerIdPost$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, userSetUserPractionerIdPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as AuthStrictHttpResponse<void>;
    })
  );
}

userSetUserPractionerIdPost.PATH = '/User/SetUserPractionerId';
